import { transform } from 'ol/proj'
import styled from 'styled-components'

const Container = styled.div`
  padding-left: 0.5rem;
`

export default function Location({ coordinates, mapUnits }) {
  let displayCoordinates = coordinates;

  let location = null;
  if (coordinates) {
    if (mapUnits === 'lat-long') {
      displayCoordinates = transform(coordinates, 'EPSG:2264', 'EPSG:4326');
      location = (
        <div>
        Latitude: {displayCoordinates[1].toFixed(5)} &nbsp;&nbsp; Longitude: {displayCoordinates[0].toFixed(5)}
        </div>
      );
    } else {
      location = (
        <Container>
        X: {displayCoordinates[0].toFixed(0)} &nbsp;&nbsp; Y: {displayCoordinates[1].toFixed(0)}
        </Container>
      );
    }
  }
  return location;
}
